// extracted by css-extract-rspack-plugin
export default {"root":"r1mcei","protect-notice":"fFYKP_","protectNotice":"fFYKP_"};